/* eslint-disable camelcase */
import { createClient } from 'contentful';

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
  host: process.env.REACT_APP_CONTENTFUL_HOST,
});

export const fetchExperience = slug =>
  client.getEntries({
    content_type: 'experience',
    'fields.slug': slug,
    'fields.activeInWeb': true,
    resolveLinks: false,
  });

export const fetchExperienceById = id =>
  client.getEntries({
    content_type: 'experience',
    'sys.id': id,
    'fields.activeInWeb': true,
    resolveLinks: false,
  });

const marketExperiencesConfig = {
  content_type: 'experience',
  'fields.activeInWeb': true,
  resolveLinks: false,
};

export const fetchExperiencesByMarketId = marketId =>
  client.getEntries({
    ...marketExperiencesConfig,
    'fields.market.sys.id': marketId,
  });

export const fetchMarketExperiencesTotal = marketId =>
  client.getEntries({
    ...marketExperiencesConfig,
    'fields.market.sys.id': marketId,
    limit: 0,
  });

export const fetchKiosk = slug =>
  client.getEntries({ content_type: 'kioskMode', 'fields.slug': slug, resolveLinks: false, include: 2 });

export const fetchMarket = slug =>
  client.getEntries({ content_type: 'market', 'fields.slug': slug, resolveLinks: false });

export const fetchAppConfig = () => client.getEntries({ content_type: 'appConfig' });

export const fetchWebsiteConfig = () =>
  client.getEntries({ content_type: 'websiteConfig', resolveLinks: false, include: 2 });

export const fetchFooterConfig = () => client.getEntries({ content_type: 'footer', resolveLinks: true, include: 2 });

export const fetchLegal = slug => client.getEntries({ content_type: 'legal', 'fields.slug': slug });

export const fetchAllMarkets = () => client.getEntries({ content_type: 'market', 'fields.comingSoon': false });

export const fetchAsset = title => client.getAssets({ 'fields.title': title });

export const fetchMarketSuggestedExperiences = marketId =>
  client.getEntries({
    content_type: 'experience',
    resolveLinks: false,
    include: 1,
    limit: 5,
    order: '-fields.orderPriority',
    'fields.market.sys.id': marketId,
    'fields.activeInWeb': true,
  });
